module.exports = __webpack_public_path__ + "img/home_stretches_video3.687d3da5.png";